package empiresmp.feature.shop.backend.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PublicShopItemData(
    @SerialName("id")
    val id: ShopItemId,
    @SerialName("title")
    val title: String,
    @SerialName("description")
    val description: String,
    @SerialName("small_desc")
    val smallDesc: String? = null,
    @SerialName("total_price")
    val totalPrice: Int,
    @SerialName("icon_base64")
    val iconBase64: String,
    @SerialName("type")
    val type: ShopItemType
)
